<template>
  <div class="presupuesto-interno-usuarios">
    <b-card header= "Usuarios" class="presupuesto-header">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showUsuarios= !showUsuarios">
        <i :class="showUsuarios ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerUsuarios" class="mt-2" v-model="showUsuarios">
        <b-row>
          <b-col>
            <b-form-group
              label="Creado por"
              label-for="usuario"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="usuario"
                :value="usuario"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Coordinador"
              label-for="usuarioCoordinador"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarUsuarioCoordinador">
                    <!-- v-if="!confirmado"> -->
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !usuarioCoordinador,
                                  'fa fa-remove': usuarioCoordinador  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="usuarioCoordinador"
                  :value="usuarioCoordinadorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <b-table hover
                responsive="sm" 
                class="registro"
                :items="usuarios" 
                :fields="usuariosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(usuario)="data">
                {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
              </template>
              <template v-slot:cell(asignado)="data">
                <b-form-checkbox
                    v-model="data.item.asignado"
                    :disabled="data.item.inactivo"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                </b-form-checkbox> 
              </template>
            </b-table>

          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-modal ref="searchUsuarioModal" 
        title="Seleccionar Usuario"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-usuario
        :coordinador="true"
        @itemSeleccionado="usuarioSeleccionado">
      </app-search-usuario>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import SearchUsuario from '../usuarios/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'

import { mapState } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'PresupuestosInternosUsuarios',
  components: {
    appSearchUsuario: SearchUsuario,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data () {
    return {
      usuariosFields: [
        {
          key: 'usuario',
          label: 'Usuarios',
        },
        {
          key: 'asignado',
          label: '',
          class: 'text-center'
        },
      ],

      showUsuarios: false,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'usuario',
      'usuarioCoordinadorId',
      'usuarioCoordinador',
      'usuarioCoordinadorNombre',
      'usuarios',

      // 'confirmado',
    ]),
  },  
  created() {
  },
  destroyed() {
  },
  methods: {
    seleccionarUsuarioCoordinador() {
      if (this.usuarioCoordinador) {
        this.$store.dispatch('presupuestointerno/setUsuarioCoordinador', null);
      }
      this.$refs.searchUsuarioModal.show();
    },
    usuarioSeleccionado(usuario) {
      this.$refs.searchUsuarioModal.hide();
        this.$store.dispatch('presupuestointerno/setUsuarioCoordinador', usuario)
          .then (() => {
            this.usuarioCoordinadorValido = null;
            this.usuarioCoordinadorInvalidoMsj = '';
          })
          .catch(error => this.showErrorMsj(error));
    }
  },
  watch: {
  }    
}
</script>

<style>
  .presupuesto-interno-usuarios .registro {
    margin-top: 30px;    
  }
  .presupuesto-interno-usuarios table thead th {
    border-top: none;
  }
  .presupuesto-interno-usuarios table tr.table-inactivo {
    color: #a9a9a9;
  }
</style>